// src/hooks/useCotizacionValidation.ts
import { useState, useCallback } from 'react'
import type { CotizacionData } from '../../types/cotizacionFormTypes'
import { validateCotizacionForm } from '../../utils/cotizacionValidation'

interface UseCotizacionValidationProps {
  formData: CotizacionData
  mode: 'view' | 'edit' | 'create'
}

export function useCotizacionValidation({
  formData,
  mode
}: UseCotizacionValidationProps) {
  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  const validateForm = useCallback(() => {
    const newErrors = validateCotizacionForm(formData, mode)
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }, [formData, mode])

  // Verifica si hay stock suficiente para todos los productos
  // Para cotizaciones, siempre permitir crear (no verificar stock)
  const checkStockAvailability = useCallback(() => {
    if (!formData.line_items?.length) return false
    
    // En modo create (nueva cotización), siempre permitir
    if (mode === 'create') {
      return true
    }
    
    // En modo edit, verificar stock solo si es necesario
    // Las cotizaciones pueden editarse sin verificar stock
    return true
  }, [formData.line_items?.length, mode])

  const isStockAvailable = checkStockAvailability()

  return {
    errors,
    setErrors,
    validateForm,
    checkStockAvailability,
    isStockAvailable
  }
}

